module.exports = __webpack_public_path__ + "static/media/medic.f7b85871.svg";